<template>
  <div
    class="uibutton"
    :style="{ color: textColor, 'background-color': backgroundColor }"
    :class="{ block: block, small: small, disabled: disabled }"
    v-if="!center"
    v-on:click="onClick"
  >
    <div class="text">
      <slot><NewTranslation v-if="path" :path="path" :params="params" /><template v-else>Button</template></slot>
    </div>
    <div
      class="icon"
      :style="{ color: backgroundColor, 'background-color': textColor, fill: backgroundColor }"
      v-if="hasIcon"
    >
      <slot name="icon"></slot>
    </div>
  </div>
  <div
    class="uibutton"
    :style="{ color: textColor, 'background-color': backgroundColor }"
    :class="{ 'is-center': center, small: small, block: block, disabled: disabled }"
    v-else
    v-on:click="onClick"
  >
    <div class="icon" :style="{ color: textColor }" v-if="hasIcon">
      <slot name="icon"></slot>
    </div>
    <div class="text">
      <slot><NewTranslation v-if="path" :path="path" :params="params" /><template v-else>Button</template></slot>
    </div>
  </div>
</template>

<script>
import NewTranslation from '@/components/i18n/NewTranslation';
export default {
  components: { NewTranslation },
  props: {
    color: {
      type: String,
      default: 'cyan',
      validator: val => ['cyan', 'green', 'white', 'gray'].includes(val),
    },
    path: {
      type: String,
    },
    params: {
      type: Object,
    },
    center: {
      type: Boolean,
    },
    block: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backgroundColor() {
      if (this.color === 'cyan') return '#1DB2D1';
      else if (this.color === 'green') return '#27D190';
      else if (this.color === 'white') return '#FFFFFF';
      else if (this.color === 'gray') return '#454F63';
      return '#fff';
    },
    textColor() {
      if (this.color === 'cyan') return '#FFFFFF';
      else if (this.color === 'green') return '#FFFFFF';
      else if (this.color === 'white') return '#6F7175';
      else if (this.color === 'gray') return '#FFFFFF';
      return '#6F7175';
    },
    hasIcon() {
      return !!this.$slots['icon'];
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.uibutton
    width: auto
    padding: 20px
    border-radius: 10px
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2)
    display: inline-block
    justify-content: space-between

    &.disabled
        opacity: .6
        cursor: not-allowed
        pointer-events: none

    &.block
        display: flex
        width: 100%

    &.small
        padding: 10px 15px

    .icon
        width: 20px
        height: 20px
        border-radius: 20px
        display: flex
        justify-content: center
        align-items: center
        svg
            width: 10px

    .is-center
        justify-content: center
        .icon
            margin-right: 10px
            svg
                width: 20px
</style>
